import { MAX_NUM_OF_PAGINATION_BUTTONS } from 'src/constants';

export const calculatePageOffset = (page, pageCount) => Math.min(
  Math.max(
    Math.ceil(MAX_NUM_OF_PAGINATION_BUTTONS / 2),
    page,
  ) - Math.floor(MAX_NUM_OF_PAGINATION_BUTTONS / 2),
  pageCount - MAX_NUM_OF_PAGINATION_BUTTONS + 1,
);
